import { connectHook } from 'app/common/components/connect-hook';
import { ProjectToolbar } from './project-toolbar.js';
import { useProjectToolbar } from './project-toolbar-hook.js';

export default connectHook(ProjectToolbar, useProjectToolbar);
